export default "__VITE_ASSET__$_G8UPbI__"